
import { UserTransformer } from '@/helpers/users/user.transformer';
import moment from "moment";
import "moment-timezone";

export class CommentTransformer {

    static transform(obj) {
        let comment = {};
        
        comment.type = obj.type.toUpperCase();

        comment.id = obj.id;
        comment.model = obj.attributes.comment_type;
        comment.commentableType = obj.attributes.commentable_type;
        comment.commentableId = obj.attributes.commentable_id;
        comment.content = obj.attributes.content;
        comment.subtype = obj.attributes.subtype;
        comment.source = obj.attributes.source;
        comment.ipAddress = obj.attributes.ip_address;
        comment.createdBy = obj.attributes.createdBy ? UserTransformer.transform(obj.attributes.createdBy) : null;
        // Timestamps in transformers MUST be in a standard international format.
        // It is up to the template that renders the time to format it because
        // different templates may require time to be rendered differently.
        // (use helper methods and filters to format dates in templates)
        comment.isSensitive = obj.attributes.is_sensitive ? true : false;
        comment.createdAt = obj.attributes.created_at;
        return comment;
    }

    static transformArray(array = []) {
        let data = [];
        array.map(function (item) {
            data.push(CommentTransformer.transform(item));
        });
        return data;
    }
}


// WEBPACK FOOTER //
// ./src/helpers/comments/comment.transformer.js